import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export const Guarantee = () => {
  return <section className="py-16 bg-beige/20" data-id="element-76">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-77">
        <FadeIn data-id="element-78">
          <div className="w-20 h-20 mx-auto bg-gold-soft/20 rounded-full flex items-center justify-center mb-6 border border-gold-soft/40" data-id="element-79">
            <ShieldCheck className="w-10 h-10 text-gold-soft" data-id="element-80" />
          </div>
          <h2 className="text-3xl md:text-4xl mb-4 font-serif" data-id="element-81">
            Garantía "Empezá Sin Miedo"
          </h2>
          <p className="text-lg text-text-brown/80 leading-relaxed" data-id="element-82">
            Tenés 7 días para probar el programa completo. Si sentís que no es
            para vos, o que no cumple con tus expectativas, te devolvemos el
            100% de tu dinero sin hacer preguntas. Tu inversión está
            completamente segura.
          </p>
        </FadeIn>
      </div>
    </section>;
};